export enum FORM_ERROR_MESSAGES {
  REQUIRED = "This field is required",
  LONG = "is too long",
  SHORT = "is too short",
  PASSWORDS_MATCH = "Passwords do not match",
  NUMBER = "must be a number",
  EMAIL = "Please enter a valid email",
  URL = "Please enter a valid URL",
  UPPERCASE = "At least 1 uppercase letter",
  LOWERCASE = "At least 1 lowercase letter",
  DIGIT = "At least 1 digit",
  ONLY_TEXT = "must be without numbers",
  ONLY_LETTERS_AND_DIGITS = "Only (A-Z), (0-9)",
  INVALID_TIME = "must be a valid time",
}
